const ContractFormSchema = {
    vin: {
        minLength: { value: 6, message: 'VIN should be at least 6 characters.' },
        maxLength: { value: 17, message: 'VIN should be 17 characters long.' },
        pattern: { value: /^[A-Za-z0-9$&+,:;=?@#|'<>.^*()%!-_]{6}([A-Za-z0-9$&+,:;=?@#|'<>.^*()%!-_]{11})?$/, message: 'VIN should be either 6 or 17 characters long.' }
    },
    gapContractNumber: {
        maxLength: { value: 25, message: 'Contract Number allows up to 25 characters long.' }
    },
    contractLastName: {
        required: { value: true, message: 'Last Name is required.' },
        maxLength: { value: 30, message: 'Last Name allows up to 30 characters long.' },
        minLength: { value: 2, message: 'Last Name should be at least 2 characters.' }
    }
};

export default ContractFormSchema;